import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconAppleStyle0 = cosmosIconCss;

const CosmosIconApple$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconApple extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '30b32e69261eb1a6cf13810bb93c38ca828f1cfd', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '1a1a44ad5105fa0f8eb4ff7fc239492d975eda40', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '3d56cdc6b6ef050f6633394aef85cf334e2f4f71', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.58 15.193c-.1.29-.206.569-.318.835a9.8 9.8 0 0 1-.968 1.74c-.508.726-.925 1.228-1.246 1.506-.498.458-1.031.693-1.603.706-.41 0-.904-.117-1.48-.353-.577-.236-1.108-.353-1.593-.353-.509 0-1.055.117-1.638.353-.585.236-1.056.36-1.416.371-.548.024-1.094-.217-1.639-.724-.347-.303-.782-.823-1.303-1.56-.56-.786-1.02-1.698-1.38-2.739-.385-1.123-.578-2.21-.578-3.264 0-1.206.26-2.246.782-3.118a4.6 4.6 0 0 1 1.64-1.659 4.41 4.41 0 0 1 2.216-.625c.435 0 1.006.135 1.715.399.707.265 1.16.4 1.36.4.148 0 .652-.157 1.507-.471.809-.291 1.49-.411 2.05-.364 1.514.122 2.651.72 3.408 1.795-1.354.82-2.024 1.97-2.01 3.444.012 1.149.428 2.105 1.247 2.864.371.352.786.624 1.247.817ZM14.77 2c.012.12.018.24.018.36 0 .9-.33 1.74-.984 2.519-.791.925-1.748 1.46-2.786 1.375a2.788 2.788 0 0 1-.02-.341c0-.864.376-1.79 1.043-2.546a4.028 4.028 0 0 1 1.272-.955c.514-.25 1-.388 1.457-.412Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconAppleStyle0; }
}, [1, "cosmos-icon-apple", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-apple"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-apple":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconApple$1);
            }
            break;
    } });
}

const CosmosIconApple = CosmosIconApple$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconApple, defineCustomElement };
